import React, {useEffect, useState} from 'react';
import './QuoteRotator.css';
import {QUOTES} from "../../texts/quotes/quotes";

const QUOTE_CHANGE_INTERVAL_MS = 10000;
const FADE_DURATION_MS = 500;
// Пауза между полным затуханием старой цитаты (и парного изображения) и
// проявлением новой — иначе при смене проскакивают визуальные гличи
const QUOTE_SWAP_GAP_MS = 500;

function getRandomQuoteIndex(currentIndex) {
  if (QUOTES.length <= 1) return 0;
  let newIndex;
  do {
    newIndex = Math.floor(Math.random() * QUOTES.length);
  } while (newIndex === currentIndex);
  return newIndex;
}

function QuoteRotator({onFactionChange, onVisibilityChange, className}) {
  const [quoteIndex, setQuoteIndex] = useState(() => getRandomQuoteIndex(-1));
  const [isQuoteVisible, setIsQuoteVisible] = useState(true);

  useEffect(() => {
    // realQuote (см. texts/quotes/*) — цитата реальной исторической личности,
    // а не фракционного персонажа лора: даже если у нее указан factionId
    // (просто как тематическая привязка), фракционный портрет для нее
    // показывать не нужно — вызывающий код (RankMatchWaiting) должен
    // показать нейтральный бюст вместо случайного скина фракции
    onFactionChange?.(QUOTES[quoteIndex]?.factionId, Boolean(QUOTES[quoteIndex]?.realQuote));
  }, [quoteIndex, onFactionChange]);

  // Позволяет синхронизировать внешний элемент (например, портрет фракции в
  // RankMatchWaiting) с тем же циклом затухания/появления, что и у цитаты —
  // тогда его смена по src совпадает с моментом, когда он и так невидим
  useEffect(() => {
    onVisibilityChange?.(isQuoteVisible);
  }, [isQuoteVisible, onVisibilityChange]);

  useEffect(() => {
    if (QUOTES.length === 0) return;

    let timeoutId;

    const changeQuote = () => {
      setIsQuoteVisible(false);
      timeoutId = setTimeout(() => {
        setQuoteIndex(prev => getRandomQuoteIndex(prev));
        setIsQuoteVisible(true);
      }, FADE_DURATION_MS + QUOTE_SWAP_GAP_MS);
    };

    const interval = setInterval(changeQuote, QUOTE_CHANGE_INTERVAL_MS);

    return () => {
      clearInterval(interval);
      clearTimeout(timeoutId);
    };
  }, []);

  const currentQuote = QUOTES[quoteIndex];

  return (currentQuote && (
    <div
      className={`loading-screen-quote ${className}`}
      style={{opacity: isQuoteVisible ? 1 : 0}}
    >
      <div className="loading-screen-quote-text">«{currentQuote.quote}»</div>
      <div className="loading-screen-quote-author">{currentQuote.author}</div>
    </div>
  ));
}

export default QuoteRotator;
